import React from 'react';
import "./Footer.css";

const Footer = () => {
    const an = new Date().getFullYear();

    return (
        <footer className='footer-cyber'>
            <div className='footer-divider'></div>

            <div className='footer-container'>
                <div className='footer-brand'>
                    <div className='logo-hex'>
                        <span>S</span>
                    </div>

                    <blockquote className='motto'>
                        Seuls les braves méritent ce qui appartient aux braves
                    </blockquote>
                </div>

                <div className='footer-bottom'>
                    <div className='legal-info'>
                        <h6>Stéphane Kikoni</h6>
                        <span className='separator'>|</span>
                        <p>&copy; {an} — Tous droits réservés.</p>
                    </div>

                    <div className='status-indicator'>
                        Disponible pour de nouveaux projets
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;